"use strict";

exports.__esModule = true;
exports.useTranslation = void 0;
var _reactIntl = require("react-intl");
var useTranslation = exports.useTranslation = function useTranslation(prefix) {
  var intl = (0, _reactIntl.useIntl)();
  var t = function t(key, variables, skipPrefix) {
    return intl.formatMessage({
      id: !skipPrefix && prefix ? prefix + "." + key : key
    }, variables);
  };
  return {
    t: t,
    intl: intl
  };
};